import { AxiosInstance } from 'axios';

export interface ICommentsHealth {
  status: string;
}

export interface ICommentsClient {
  getHealth(): Promise<ICommentsHealth>;
}

export function createCommentsClient(instance: AxiosInstance): ICommentsClient {
  async function getHealth(): Promise<ICommentsHealth> {
    const resp = await instance.get<ICommentsHealth>('/comments/health');

    return resp.data;
  }

  return {
    getHealth,
  };
}
